import { inject } from "mobx-react";
import type { IUploadStores } from "./AppUpload";

type IStoresToProps<TStores, TProps extends object> = (stores: TStores) => TProps;

export function injectFromAppUpload<TProps extends object>(fn: IStoresToProps<IUploadStores, Partial<TProps>>) {
    return inject(fn);
}
